import React, { useEffect, useState } from 'react';
import { Table, Space, Select } from 'antd';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import { FileExcelOutlined } from '@ant-design/icons';
import { Button } from 'components/atoms'
import * as XLSX from 'xlsx';
import { selectBoxFilterOption } from 'utils/form-utils';

interface FormItemProps {
  salesList: any[] | undefined;  
  hiddenColumns: string[];  
  codeList: any[] | undefined;
  actPage: string;
  detailCode: string;
  year: string;
  startMonth: string;
  endMonth: string;
  months: any[] | undefined;
  onChangeDetailMonth: (start:string, end:string, value:string) => void;
}

const SALESTable = ({salesList, hiddenColumns, codeList, actPage, detailCode, months, year, startMonth, endMonth, onChangeDetailMonth}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [viewColumns, setViewColumns] = useState<any[]>([]);
  const [viewColumnCnt, setViewColumnCnt] = useState<number>(0);

  const sharedOnCell = (record) => {
    if (record.type === 'total') {
      return { colSpan: 0 };
    }
    return {};
  };

  const columns: ColumnsType<any> = [
    {
      title: '진행',
      dataIndex: 'project_step',
      key: 'project_step',
      width: '50px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },     
    {
      title: '강의주제',
      dataIndex: 'lecture_subject1',
      key: 'lecture_subject1_1',
      width: '150px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },  
    {
      title: '강의구분',
      dataIndex: 'lecture_type1',
      key: 'lecture_type1_1',
      width: '150px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },   
    {
      title: '기간',
      dataIndex: 'start_date',
      key: 'start_date_1',
      width: '150px',
      align: 'center',  
      onCell: sharedOnCell,  
      render: (start_date, record) => {
        return (
          <label>{start_date}~{record.end_date}</label>
        )
      }  
    },
    {
      title: '기업명',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '130px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },        
    {
      title: '프로젝트이름',
      dataIndex: 'title',
      key: 'title',
      width: 'auto',
      align: 'center',
      ellipsis: true,
      onCell: (record) => ({
        colSpan: record.type === 'total' ? viewColumnCnt-2 : 1,
      }),
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value}</label>
          ):(
            <label>{value}</label>
          )
        )
      }
    },      
    {
      title: '기간',
      dataIndex: 'start_date',
      key: 'start_date_2',
      width: '150px',
      align: 'center',   
      onCell: sharedOnCell, 
      render: (start_date, record) => {
        return (
          <label>{start_date}~{record.end_date}</label>
        )
      }  
    },  
    {
      title: '강의구분',
      dataIndex: 'lecture_type1',
      key: 'lecture_type1_2',
      width: '150px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    }, 
    {
      title: '강의주제',
      dataIndex: 'lecture_subject1',
      key: 'lecture_subject1_2',
      width: '150x',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },  
    {
      title: '강의시간',
      dataIndex: 'time_count',
      key: 'time_count',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value}</label>
          ):(
            <label>{value}</label>
          )
        )
      }
    },  
    {
      title: '매출',
      dataIndex: 'sale_price',
      key: 'sale_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },                                            
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
  const onExcelDownload = () => {
    const header: string[] = [];
    const datas: any[] = [];
    const merges: any[] = [];

    if ("sales" === actPage.toString()) {
      header.push('진행');
      header.push('기간');
      header.push('기업명');
      header.push('프로젝트이름');
      header.push('강의구분');
      header.push('강의주제');
      header.push('강의시간');
      header.push('매출');
   } else if ("type" === actPage.toString()) {
      header.push('진행');
      header.push('강의구분');
      header.push('기업명');
      header.push('프로젝트이름');
      header.push('기간');
      header.push('강의주제');
      header.push('강의시간');
      header.push('매출');
    } else if ("subject" === actPage.toString()) {
      header.push('강의주제');
      header.push('기업명');
      header.push('프로젝트이름');
      header.push('기간');
      header.push('강의구분');
      header.push('강의시간');
      header.push('매출');      
    } else if ("company" === actPage.toString()) {
      header.push('진행');      
      header.push('기업명');
      header.push('프로젝트이름');
      header.push('기간');
      header.push('강의구분');
      header.push('강의주제');      
      header.push('강의시간');
      header.push('매출');        
    }

    let tot_sales = 0;
    let tot_time = 0;      
    salesList?.forEach((item, index) => {
      if (item.type === 'info') {
        const newItem = {
          '진행': item.project_step,
          '기간': item.start_date+'~'+item.end_date,
          '기업명': item.company_name,
          '프로젝트이름': item.title,
          '강의구분': item.lecture_type1,
          '강의주제': item.lecture_subject1,
          '강의시간': item.time_count,
          '매출': item.sale_price,
        }
        datas.push(newItem);

        tot_sales += item.sale_price?item.sale_price:0;
        tot_time += item.time_count?item.time_count:0;          
      } else {
        const newItem = {
          '진행': item.project_step,
          '기간': item.title,
          '기업명': item.title,
          '프로젝트이름': item.title,
          '강의구분': item.title,
          '강의주제': item.title,
          '강의시간': item.time_count,
          '매출': item.sale_price,
        }
        datas.push(newItem);
        merges.push({s: {c:0, r:index+1}, e: {c:5, r:index+1}});
      }
    });

    const newItem = {
      '진행': '합계',
      '기간': '합계',
      '기업명': '합계',
      '프로젝트이름': '합계',
      '강의구분': '합계',
      '강의주제': '합계',      
      '강의시간': tot_time,
      '매출': tot_sales,
    }
    datas.push(newItem);
    merges.push({s: {c:0, r:datas.length}, e: {c:4, r:datas.length}});

    const book = XLSX.utils.book_new();
    const nurses = XLSX.utils.json_to_sheet(
      datas, 
      { 
        header : header, 
        skipHeader : false 
      } 
    );

    nurses["!cols"] = [
      { wpx : 150 } 
    , { wpx : 150 }       
    , { wpx : 200 } 
    , { wpx : 200 }  
    , { wpx : 200 }  
    , { wpx : 200 } 
    , { wpx : 100 } 
    , { wpx : 150 } 
    ]
    if (merges.length > 0) {
      nurses["!merges"]  = merges;   
    }

    XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
    XLSX.writeFile( book, year+'_'+startMonth +'월_'+endMonth+'월_매출.xlsx'); 
  }  

  useEffect(() => {
    if (!!hiddenColumns) {
      const newColumns = columns.filter((item) => hiddenColumns.findIndex((col)=>col === item.key) < 0);
      setViewColumns(newColumns);
      setViewColumnCnt(newColumns.length);
    }

  }, [hiddenColumns, salesList]);
  

  /* ======================================================
  * hooks
  * ====================================================== */
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space style={{width:'100%', justifyContent:'space-between', marginTop:'20px'}}>
        <Space>
        {(!!codeList && codeList.length > 0) && (
          <Select 
            placeholder={"선택하세요."}
            value={detailCode}
            options={codeList}
            onSelect={(value)=>{onChangeDetailMonth(startMonth, endMonth, value)}}
            style={{width: '150px'}}
            showSearch={true} 
            optionFilterProp="label"    
            filterOption={selectBoxFilterOption}            
          />  
        )}   
          <Select 
            value={startMonth}
            options={months}
            onSelect={(value)=>{onChangeDetailMonth(value, endMonth, detailCode)}}
            style={{width: '80px'}}
          /> 
          <Select 
            value={endMonth}
            options={months}
            onSelect={(value)=>{onChangeDetailMonth(startMonth, value, detailCode)}}
            style={{width: '80px'}}
          />       
        </Space>
        <Space>
          <Button icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀다운로드</Button>
        </Space>              
      </Space>
      <TableWrapper isSearch={false}>
        <Table
          tableLayout="fixed"
          dataSource={salesList}
          columns={viewColumns}
          pagination={false}
          onRow={(record, index) => {
            return {
              onClick: () => {
                if (record.group_id) {
                  const groupInfo = record.group_id.split('_');
                  if (groupInfo.length === 3) {
                    if (groupInfo[0] === 'b2b') {
                      if (record.project_step === 'A') {
                        window.open(`/b2b/confirm?group_id=${groupInfo[2]}`);
                      } else {
                        window.open(`/b2b/consult?group_id=${groupInfo[2]}`);
                      }
                    } else if (groupInfo[0] === 'b2c') {
                      window.open(`/b2c/lecture?group_id=${groupInfo[2]}`);
                    } else if (groupInfo[0] === 'pml') {
                      window.open(`/b2c/pml?group_id=${groupInfo[2]}`);
                    }
                  }
                }
              }
            }
          }}
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}
          summary={pageData => {
            let tot_sales = 0;
            let tot_time = 0;
            pageData.forEach((item) => {
              if (item.type === 'info') {
                tot_sales += item.sale_price?item.sale_price:0;
                tot_time += item.time_count?item.time_count:0;
              }
            });
            return (
              <>
                <Table.Summary.Row style={{backgroundColor:'#f7f7f7', fontWeight:'500', color:'red'}}>
                  <Table.Summary.Cell index={1} colSpan={viewColumnCnt-2}  align='center'>합계</Table.Summary.Cell>
                  <Table.Summary.Cell index={9} colSpan={1} align='center'>{tot_time.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>
                  <Table.Summary.Cell index={10} colSpan={1} align='right'>{tot_sales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
        />
      </TableWrapper>  
    </Space>
  );
};

export default SALESTable;
